import { Tooltip } from 'antd';
import { SafetyCertificateOutlined, StopOutlined } from '@ant-design/icons';

export type LicenseFilterValue = boolean | null;

const OPTIONS: Array<{
  value: boolean;
  label: string;
  hex: string;
  bg: string;
  Icon: typeof SafetyCertificateOutlined;
}> = [
  { value: true,  label: 'Litsenziyli',  hex: '#0EA5E9', bg: '#ECFEFF', Icon: SafetyCertificateOutlined },
  { value: false, label: 'Litsenziyasiz', hex: '#94A3B8', bg: '#F1F5F9', Icon: StopOutlined },
];

interface LicenseFilterProps {
  /** `true` = Litsenziyli, `false` = Litsenziyasiz, `null` = no filter. */
  value: LicenseFilterValue;
  onChange: (next: LicenseFilterValue) => void;
}

/**
 * Two-pill filter for Soliq license status. A driver is considered
 * Litsenziyli iff at least one of `selfEmploymentStatus` / `ipStatus` is
 * `REGISTERED` — i.e. they're legally allowed to operate as taxi.
 */
export const LicenseFilter: React.FC<LicenseFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <span style={{ display: 'inline-flex', gap: 6, marginLeft: 12, verticalAlign: 'middle' }}>
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        const { Icon } = opt;
        return (
          <Tooltip
            key={String(opt.value)}
            title={active ? 'Filterni olib tashlash' : `Filter: ${opt.label}`}
          >
            <button
              type="button"
              onClick={() => onChange(active ? null : opt.value)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 10px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.15s',
                color: active ? '#fff' : opt.hex,
                background: active ? opt.hex : opt.bg,
                border: `1px solid ${active ? opt.hex : opt.hex + '33'}`,
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
              }}
            >
              <Icon style={{ fontSize: 13 }} />
              {opt.label}
            </button>
          </Tooltip>
        );
      })}
    </span>
  );
};
